export default __webpack_public_path__ + "static/media/LK.2b5b6342.svg";